import moment from "moment"
import { getVesselAge } from "../helpers/addYardActivity"
import {
  VesselStayWithYardActivity,
  getLatestTwoDryDock,
  getYearsToDryDock,
  getDDinDDYear,
} from "../helpers/getLastestDryDock"
import { VesselStay } from "../hooks/useFetchVesselStays"
import { VesselDetails } from "../hooks/usePrevetAPI"
import { Card } from "react-bootstrap"

function getDDCategory(stay: VesselStayWithYardActivity) {
  if (stay.yard_activity === "DD-S") {
    return { Category: "Short", TextType: "danger" }
  }
  if (stay.yard_activity === "DD-M") {
    return { Category: "Medium", TextType: "warning" }
  }
  if (stay.yard_activity === "DD-L") {
    return { Category: "Long", TextType: "success" }
  }
  if (stay.yard_activity === "DD-R") {
    return { Category: "DD/Repair/IWS", TextType: "danger" }
  }
  if (stay.yard_activity === "DD-Late") {
    if (stay.yard_duration > 25) {
      return { Category: "Long & Late", TextType: "warning" }
    }
    if (stay.yard_duration > 14) {
      return { Category: "Medium & Late", TextType: "warning" }
    }
    return { Category: "Short & Late", TextType: "warning" }
  }
}

function renderLatestDryDock(DDstays: VesselStayWithYardActivity[]) {
  const stays = DDstays[0]
  const date = moment(stays.date_from)
  const DDCategory = getDDCategory(stays)

  return (
    <>
      <div className="d-flex flex-column w-50">
        <div className="text-muted">Last DD</div>
        <div className="d-flex align-items-end h-100">
          {date.format("MMM")} '{date.format("YY")}
        </div>
      </div>
      <div className="d-flex flex-column w-50">
        <h6 className={`text-${DDCategory?.TextType}`}>
          {DDCategory?.Category}
        </h6>
        <div className="d-flex align-items-end h-100">
          {stays.yard_duration} days
        </div>
      </div>
    </>
  )
}

function getRecentRepair(stays: VesselStay[]) {
  return stays.find(
    (stays) => stays.yard_activity === "R" || stays.yard_activity === "DD-R"
  )
}

function getRepairsCount(stays: VesselStay[]) {
  return stays.filter(
    (stay) => stay.yard_activity === "R" || stay.yard_activity === "DD-R"
  ).length
}

export function PrevetDDWidget({
  vesselDetails,
  vesselStays,
}: {
  vesselDetails: VesselDetails
  vesselStays: VesselStay[]
}) {
  const now = moment()
  const currDate = now.format("YYYY-MM-DD")
  const vesselAge = getVesselAge({
    built: Number(vesselDetails.built),
    date: currDate,
  })

  const yearsToDryDock = getYearsToDryDock(Number(vesselDetails.built))
  const DDinDDYear = getDDinDDYear(vesselStays, now)
  const lastestTwoDryDock = getLatestTwoDryDock(vesselStays)
  console.log(lastestTwoDryDock)
  const oapApply = vesselAge >= 20 ? true : false
  const recentRepair = getRecentRepair(vesselStays)
  const repairCount = getRepairsCount(vesselStays)


  //previous implementation of ddYearsColor
  /* const ddYearsColor =
    yearsToDryDock !== null && yearsToDryDock !== undefined
      ? yearsToDryDock >= 4
        ? "success"
        : yearsToDryDock >= 1
        ? "warning"
        : "danger"
      : "muted" */

  
  function getDryDockCss({
    yearsToDryDock,
    hasDDinDDYear,
  }: {
    yearsToDryDock: number
    hasDDinDDYear: boolean
  }) {
    if (yearsToDryDock === 0 && !hasDDinDDYear) {
      return "danger"
    }
    if (yearsToDryDock === 0 && hasDDinDDYear) {
      return "success"
    }
    if (yearsToDryDock <= 3) {
      return "warning"
    }
    if (yearsToDryDock > 3 && yearsToDryDock < 5) {
      return "success"
    }
    return "muted"
  }

  return (
    <>
      <Card.Body>
        <Card.Title>Dry Dock - IWS - Repairs</Card.Title>
        <div className="w-100 mt-5 d-flex align-items-center">
          <div className="d-inline-flex w-50 justify-content-start gap-3 align-items-center">
            <div className="text-muted w-50">Est years to DD</div>
            <h1
              className={`text-${getDryDockCss({
                yearsToDryDock,
                hasDDinDDYear: DDinDDYear.length > 0,
              })}`}
            >
              {yearsToDryDock === 5 ? "0" : yearsToDryDock}
            </h1>
          </div>
          {lastestTwoDryDock.length > 0 ? (
            <div className="d-inline-flex w-50 justify-content-between ps-1 h-100">
              {renderLatestDryDock(lastestTwoDryDock)}
            </div>
          ) : (
            <div className="d-inline-flex w-50 justify-content-center ps-1 h-100">
              No DD Found
            </div>
          )}
        </div>
        {/* Divider */}
        <div className="w-full my-1 h-1 border border-top border-light" />
        {/* Repairs */}
        <div className="w-100 mt-1 d-flex align-items-center">
          {oapApply || repairCount > 0 ? (
            <>
              {recentRepair && (
                <>
                  <div className="w-100 d-flex align-items-center">
                    <div className="d-inline-flex w-50 justify-content-start gap-3 align-items-center">
                      <div className="text-muted w-50">Total IWS / Repairs</div>
                      <h1>{getRepairsCount(vesselStays)}</h1>
                    </div>
                    <div className="d-inline-flex w-50 justify-content-start gap-3 align-items-center">
                      <div className="text-muted w-50">Last IWS / Repairs</div>
                      <div className="d-flex flex-column align-items-start w-50">
                        <div className="text-muted">
                          {moment(recentRepair.date_from).format("MMM 'YY")}
                        </div>
                        <div className="text-start">{recentRepair.port}</div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          ) : (
            <div className="text-muted mx-auto mt-2">No recent repairs</div>
          )}
        </div>
      </Card.Body>
    </>
  )
}
